import _fails from "../internals/fails";
var exports = {};
var fails = _fails;
exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});
export default exports;